import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminDashboard from "./Components/AdminDashboard";
import { getSupabaseClient } from "./Components/Database/supabaseClient";
import Logo from "./Components/Helpers/Logo";
import GoogleSignUp from "./Components/Signup/GoogleSignUp";

const MainApp = () => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  const supabase = getSupabaseClient();

  const formatUsername = (displayName) => {
    if (!displayName) return null;
    return displayName.toLowerCase().replace(/\s+/g, "_");
  };

  useEffect(() => {
    const checkUserInSupabase = async () => {
      const savedUser = JSON.parse(localStorage.getItem("user"));
      if (savedUser) {
        const { data } = await supabase
          .from("users")
          .select("*")
          .eq("firebase_uid", savedUser.uid)
          .single();

        if (data) {
          setUser(data);
          const formattedUsername = formatUsername(data.displayName);
          if (formattedUsername) {
            navigate(`/${formattedUsername}`);
          }
        }
      }
    };

    checkUserInSupabase();
  }, [navigate, supabase]);


  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center items-center py-16 px-4">
      {!user ? (
        <div className="bg-white shadow-lg rounded-lg p-10 w-full sm:w-96 lg:w-80">
          <div className="text-center mb-10">
            <Logo />
            <p className="text-lg text-gray-700 font-medium">
              Sign up with your Google Account
            </p>
          </div>

          <GoogleSignUp/>
        </div>
      ) : (
        <>
          <AdminDashboard />
        </>
      )}
     
    </div>
  );
};

export default MainApp;
